<template>
     <div class="container" v-title="'官方媒体'">
         <Navigation-bar title="官方媒体"></Navigation-bar>
        <div class="container_content">
            <div id="OfficialMedia">
                <div class="tab" v-scrollShadow="tabIndex == 0 && roll">
                    <ul>
                        <li :class="{'active': tabIndex == 0}" @click="select(0)">协会官媒</li>
                        <li :class="{'active': tabIndex == 1}" @click="select(1)">协会会刊</li>
                    </ul>
                </div>
                <div class="journal_tab" :show="tabIndex" v-show="tabIndex == 1" v-scrollShadow="tabIndex == 1 && roll">
                    <ul>
                        <li v-for="(item,index) in Journal" :key="index"
                            :class="{'active':index == journalTabIndex}"
                            @click="selectJournal(index)"
                        >{{item.year}}年</li>
                    </ul>
                </div>
                <div class="OM_scroll" v-scroll="roll">
                    <div class="OM_content">
                        <div class="media" v-show="tabIndex == 0">
                            <img src="@images/Association/协会官媒@2x.png">
                        </div>
                        <div class="journal" v-show="tabIndex == 1">
                            <ul v-if="Journal.length > 0">
                                <li v-for="(item,index) in Journal[journalTabIndex].list" :key="index" @click="openFile(item.date)">
                                    <div class="img">
                                        <div></div>
                                        <img :src="getImg(item.date)" @error="this.remove()">
                                        <img class="frame" src="@images/Association/会刊/会刊框@2x.png">
                                    </div>
                                    <div class="month"><span>{{item.date}}</span></div>
                                    <div class="text">《职工体育》第{{item.issue}}期</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>
<script>
import $ from 'jquery';
export default {
    name:"OfficialMedia",
    data(){
        return{
            roll:0,
            tabIndex:0,
            Journal:[],
            journalTabIndex:0
        }
    },
    created(){
        $.ajax({
            url: process.env.VUE_APP_PUBLIC_URL + '/会刊/index.json',
            contentType:"application/json",
            success:(data)=>{
                this.Journal = data || [];
            }
        })
    },
    activated(){
        this.roll -= 0.001;
    },
    watch:{
        journalTabIndex:function(index){
            var left = 0;
            if(index-1 > 0){
                let w1 = $('.journal_tab').outerWidth(),
                    w2 = $('.journal_tab ul').outerWidth();
                $.each($('.journal_tab ul li'),function(i,item){
                    if(i < index-1){
                        left += $(item).outerWidth(true);
                    }
                })
                if(w2 - w1 < left){
                    left = w2 - w1;
                }
            }
            $('.journal_tab').scrollLeft(left);
        }
    },
    methods:{
        select(index){
            this.tabIndex = index;
            this.roll = 0;
        },
        selectJournal(index){
            this.journalTabIndex = index;
            this.roll = 0;
        },
        getImg(date){
            var src = '';
            if(date){
                src = process.env.VUE_APP_PUBLIC_URL + `/会刊/images/${date.replace('.','-')}.jpg`;
            }
            return src;
        },
        openFile(date){
            var url = process.env.VUE_APP_PUBLIC_URL;
            if(date){
                this.$navigation.go('/Rules/OnlinePreview?type=pdf&file_url='+encodeURIComponent(url + `/会刊/files/${date.replace('.','-')}.pdf`));
            }
        },
    }
}
</script>
<style lang="scss" scoped>
#OfficialMedia{
    position: relative;
    overflow: hidden;
    .tab{
        width: 100%;
        height: 80px;
        background: #ffffff;
        position: relative;
        z-index: 2;
        ul{
            display: flex;
            height: 100%;
            li{
                width: 50%;
                @include line-height(80px);
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
                text-align: center;
                &.active{
                    color: #EC1B24;
                    border-bottom: 4px #EC1B24 solid;
                    box-sizing: border-box;
                }
            }
        }
    }
    .journal_tab{
        width: 100%;
        height: 80px;
        background: #ffffff;
        overflow-x: auto;
        position: relative;
        z-index: 1;
        ul{
            width: max-content;
            height: 100%;
            display: flex;
            white-space: nowrap;
            padding: 0 22px 0 40px;
            li{
                @include line-height(80px);
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 400;
                margin-right: 38px;
                &:last-of-type{
                    margin-right: 0;
                }
                &.active{
                    color: #EC1B24;
                    font-weight: 500;
                    border-bottom: 4px #EC1B24 solid;
                    box-sizing: border-box;
                }
            }
        }
    }
    .OM_scroll{
        height: 100%;
        width: 100%;
        overflow-y: auto;
    }
    .journal_tab[show='0'] + .OM_scroll{
        height: calc(100% - 80px);
    }
    .journal_tab[show='1'] + .OM_scroll{
        height: calc(100% - 160px);
    }
    .OM_content{
        .media img{
            width: 100%;
        }
        .journal{
            width: 100%;
            padding: 40px;
            box-sizing: border-box;
            ul li{
                width: 324px;
                height: 460px;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
                border-radius: 12px;
                margin-right: 22px;
                margin-bottom: 20px;
                display: inline-block;
                &:nth-of-type(2n){
                    margin-right: 0;
                }
                .img{
                    width: 324px;
                    height: 324px;
                    background: #E4F0F9;
                    border-radius: 12px 12px 0px 0px;
                    margin-bottom: 24px;
                    position: relative;
                    >div,
                    img{
                        width: 164px;
                        height: 222px;
                        position: absolute;
                        top: 52px;
                        left: 80px;
                    }
                    >div{
                        background: #D8D8D8;
                    }
                    .frame{
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }
                .month{
                    text-align: center;
                    margin-bottom: 8px;
                    span{
                        display: inline-block;
                        padding: 6px 12px;
                        font-size: 24px;
                        color: #EC1B24;
                        font-weight: 500;
                        border: 2px solid rgba(236,27,36,1);
                        border-radius: 4px;
                    }
                }
                .text{
                    font-size: 28px;
                    color: #1B1C1E;
                    line-height: 40px;
                    font-weight: 500;
                    text-align: center;
                }
            }
        }
    }
}
</style>